import { ReactComponent } from './money-xl.svg';
export const MoneyIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=money-xl.js.map